\rtr-payment-prepayment
    position: relative
    display: block

\rtr-payment-giftcard
    width: 100%
    min-height: 130px
    .RTPGiftCardCodeField
        position: relative
        width: 100%
        height: 44px
        display: flex
        justify-content: center
        align-items: center
        border-radius: $globalButtonRounding
        font-size: 18px
        border: 1px solid rgb($globalSettingsStrokeSecondary)
    .RTPcodeXButton
        position: absolute
        right: 12px
        top: 12px
        cursor: pointer
        &:hover
            opacity: 0.7

.RTPOptionsContainer
    .RadioContainer
        min-width: unset
    @media #{$tablet}
        width: 100%
        display: flex
        flex-direction: row
        flex-wrap: wrap
        justify-content: space-between
        box-sizing: border-box
.RTPOptionsTitle
    width: 100%
    font-size: 14px
    font-weight: 700
    box-sizing: border-box

.RTPTitle
    width: 100%
    font-size: 16px
    font-weight: 700
    box-sizing: border-box

.RTPItemContainer
    height: 50px
    width: calc(100% + 40px)
    margin: 0 -20px
    padding: 0 20px
    display: flex
    flex-direction: column
    box-sizing: border-box
    border-bottom: 1px solid rgb($globalSettingsStrokeTertiary)
    justify-content: center
    overflow: hidden
    @media #{$tablet}
        width: 100%
        margin: 10px 0
        padding: 0 10px
        height: 40px
        border: 1px solid rgb($globalSettingsStrokeSecondary)
        box-sizing: border-box
        border-radius: $globalButtonRounding
        box-shadow: $globalButtonShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalButtonShadowSecondary rgba($globalSettingsBackgroundShadowColor,0.05)
        background-color: rgb($globalSettingsBackgroundPrimary)
        &:hover
            border: 1px solid rgb($globalSettingsStrokePrimary)
        &:focus-within
            border: 1px solid rgb($globalSettingsStrokePrimary)
    &:not(:first)
        padding-left: 48px
.RTPItemContainerHalf
    @media #{$tablet}
        width: calc(50% - 10px)
.RTPItemContainerOrder
    height: 51px
    width: calc(100% + 40px)
    margin: 0 -20px
    padding: 0 20px
    display: flex
    flex-direction: column
    box-sizing: border-box
    border-bottom: 1px solid rgb($globalSettingsStrokeTertiary)
    justify-content: center
    overflow: hidden
    &:not(:first)
        padding-left: 48px

.RTPInputSEPA
    padding-left: 24px
    font-size: 14px
    font-weight: 400
    outline: none
    border: none
    &:hover
        outline: none
        border: none
    &:focus
        outline: none
        border: none
    &::placeholder
        color: rgb($globalSettingsFontTertiary)
        opacity: 1
    &:-ms-input-placeholder
        color: rgb($globalSettingsFontTertiary)
    &::-ms-input-placeholder
        color: rgb($globalSettingsFontTertiary)

.RTPOptionError
    width: calc(100% + 40px)
    border: 1px solid rgb($globalErrorBackground)
    padding: 0 20px
    margin: 0 -20px
    @media #{$tablet}
        width: calc(100% + 20px)
        border: 1px solid rgb($globalErrorBackground)
        border-radius: $globalButtonRounding
        padding: 0 10px
        margin: 0 -10px

.RTPOnePaymentContainer
    width: calc(100% + 40px)
    height: 51px
    padding: 0 20px
    margin: 0 -20px
    display: flex
    flex-direction: row
    justify-content: space-between
    align-items: center
    font-size: 14px
    .SelectedMethodText
        display: flex
        flex-direction: row
        justify-content: space-between
        align-items: center
        font-weight: 700
        svg
            margin-right: 10px
    .ChangeMethodLink
        color: rgb($globalSettingsFontSecondary)
        cursor: pointer
        font-size: 12px
        text-decoration: underline
        &:hover
            color: rgb($globalSettingsFontPrimary)

.RTPItemLabelContainer
    position: relative
    width: 100%
    height: 40px
    margin-bottom: 10px
    padding: 3px 10px
    display: flex
    flex-direction: row
    justify-content: space-between
    align-items: center
    background-color: rgb($globalSettingsBackgroundPrimary)
    border: 1px solid rgb($globalSettingsStrokeSecondary)
    border-radius: $globalButtonRounding
    font-size: 14px
    cursor: pointer
    overflow: hidden
    box-shadow: $globalButtonShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalButtonShadowSecondary rgba($globalSettingsBackgroundShadowColor,0.05)
    &:hover
        border: 1px solid rgb($globalSettingsStrokePrimary)
    &:focus-within
        border: 1px solid rgb($globalSettingsStrokePrimary)
    &.prepayment, &.reservation
        stroke: rgb($globalSettingsFontSecondary)
.RTPItemLabelContainerOrder
    position: relative
    width: calc(100% + 40px)
    height: 51px
    margin: 0 -20px
    padding: 0px 20px
    display: flex
    flex-direction: row
    align-items: center
    justify-content: space-between
    font-size: 16px
    box-sizing: border-box
    border-bottom: 1px solid rgb($globalSettingsStrokeTertiary)
    cursor: pointer
    overflow: hidden
    &:hover
        border-bottom: 1px solid rgb($globalSettingsStrokePrimary)
    &.prepayment, &.reservation
        stroke: rgb($globalSettingsFontSecondary)
.RTPSVGContainer
    height: 100%
    box-sizing: border-box
    display: flex
    flex-shrink: 0
    flex-flow: column
    align-items: center
    justify-content: center
    flex-direction: row
    gap: 6px
    @media #{$tablet}
        position: absolute
        right: 20px

    form
        width: 100%

    .stripe-cc
        order: 1
    .stripe-sepa
        order: 2
    .paypal
        order: 3
    .prepayment
        order: 4
    .reservation
        order: 5
    .giftcard
        order: 99
.RTPBLik
    width: 100%
    display: flex
    flex-direction: column
    .RTPBLikFields
        width: 100%
        display: flex
        gap: 2px
        .RTPBLikSeparator
            width: 10px
        .RTPBLikField
            width: 20px
            height: 32px
            border: 0
            border-bottom: 2px solid rgb($globalSettingsStrokeSecondary)
            color: rgb($globalSettingsFontPrimary)
            text-align: center
            font-size: 18px
            font-weight: 400
            &:hover
                border-bottom: 2px solid rgb($globalSettingsStrokePrimary) !important
            &:focus
                border-bottom: 2px solid rgb($globalSettingsFontTertiary) !important
                outline: none !important
        ::-webkit-outer-spin-button,
        ::-webkit-inner-spin-button
            -webkit-appearance: none
            margin: 0
        input[type=number]
            -moz-appearance: textfield
